import { useCallback } from 'react';
import cn from 'bem-cn';

import { feedActions, useActions } from '../../../store';
import { Avatar, Cut, List, Stack, Tag } from '../../UI';
import { getCatagoryLink, getCategoryId } from '../../../utils/getCategoryLink';
import { mapCategoriesToRussian } from '../../../utils/categories';

import { PromptInfoHeaderProps } from './PromptInfoHeader.types';
import './PromptInfoHeader.scss';

const b = cn('prompt-info-header');

const extractTagKey = (item: string) => `category-${item}`;

export const PromptInfoHeader = (props: PromptInfoHeaderProps) => {
    const { image, title, description, categories, clickableCategories = true } = props;

    const { setCategory } = useActions(feedActions);

    const tags = mapCategoriesToRussian(categories);

    const handleTagClick = useCallback(
        (item: string) => {
            return () => {
                const category = getCategoryId(item);

                if (category) {
                    setCategory(category);
                }
            };
        },
        [setCategory],
    );

    const renderTag = (item: string) => (
        <Tag
            text={item}
            link={clickableCategories ? getCatagoryLink(item) : undefined}
            onClick={clickableCategories ? handleTagClick(item) : undefined}
        />
    );

    return (
        <Stack className={b()}>
            {image && (
                <Stack alignItems="center" className={b('image-container')}>
                    <Avatar image={image} size="large" />
                </Stack>
            )}
            <Stack spacing={8}>
                <List
                    direction="row"
                    justifyContent="center"
                    className={b('categories')}
                    items={tags}
                    renderItem={renderTag}
                    keyExtractor={extractTagKey}
                />
                <h1>{title}</h1>
                {description && <Cut maxLines={4}>{description}</Cut>}
            </Stack>
        </Stack>
    );
};
